import * as tslib_1 from "tslib";
var PitFile_1;
import { jsonMember, jsonObject } from "typedjson";
import { DxGridRow } from "../../dx-grid/domain/dx-grid-row";
/** Прикрепленный файл */
let PitFile = PitFile_1 = class PitFile extends DxGridRow {
    constructor(fields) {
        super();
        if (fields)
            Object.assign(this, fields);
    }
    getRowId() {
        return this.fileId;
    }
    setComment(comment) {
        this.comment = comment;
        return this;
    }
    setFileEntityId(entityId) {
        this.fileEntityId = entityId;
        return this;
    }
    static fromLoadedFile(file, fileTypeId, user) {
        return new PitFile_1({
            fileId: file.id,
            fileName: file.name,
            createDate: file.createDate,
            size: file.size,
            typeFileId: fileTypeId
        });
    }
};
tslib_1.__decorate([
    jsonMember({ constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitFile.prototype, "fileEntityId", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], PitFile.prototype, "fileName", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitFile.prototype, "fileId", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitFile.prototype, "typeFileId", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitFile.prototype, "attachUserId", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], PitFile.prototype, "attachUserName", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], PitFile.prototype, "attachUserPost", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], PitFile.prototype, "comment", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: Boolean, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Boolean)
], PitFile.prototype, "isDeleted", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitFile.prototype, "size", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: Date, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Date)
], PitFile.prototype, "createDate", void 0);
PitFile = PitFile_1 = tslib_1.__decorate([
    jsonObject,
    tslib_1.__metadata("design:paramtypes", [Object])
], PitFile);
export { PitFile };
